// extracted by mini-css-extract-plugin
module.exports = {"tiny":"Space_tiny__1X1SY","small":"Space_small__17a_u","medium":"Space_medium__3O7Vw","large":"Space_large__Y2e4f","xlarge":"Space_xlarge__qaAdJ"};